import en from './locales/en.json' with { type: 'json' };
import es from './locales/es.json' with { type: 'json' };

export const appLocales = ['en', 'es'];
export const defaultLocale = 'en';

export const messages = { en, es };

const i18n = {
  appLocales,
  defaultLocale,
  messages,
};

export default i18n;
